import React from "react";
import ProductIcon from "./ProductIcons";

export default function BenefitStrip({ heading, items = [], className = "" }) {
  return (
    <div
      className={[
        "grid gap-8 border-t border-ink/8 pt-10 md:grid-cols-12 md:items-start",
        className,
      ].join(" ")}
    >
      {heading ? (
        <h3 className="max-w-xs text-2xl font-semibold tracking-display text-ink md:col-span-3 md:text-3xl">
          {heading}
        </h3>
      ) : null}
      <div
        className={[
          "grid gap-8 sm:grid-cols-3",
          heading ? "md:col-span-9" : "md:col-span-12",
        ].join(" ")}
      >
        {items.map((item) => (
          <div key={item.title} className="min-w-0">
            <div className="flex items-center gap-3">
              {item.n ? (
                <span className="text-xs font-semibold uppercase tracking-[0.16em] text-muted">
                  {item.n}
                </span>
              ) : item.icon ? (
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-hint/12 text-hint-deep">
                  <ProductIcon name={item.icon} />
                </span>
              ) : null}
              <h3 className="text-base font-semibold tracking-tight text-ink">{item.title}</h3>
            </div>
            <p className="mt-2 text-sm leading-relaxed text-muted">{item.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
